import React from 'react';

import {assertAndContinue} from 'Asserts';
import {BenchlingAppType, MODEL_CONSTANT_BY_APP_CONFIG_TYPE} from 'benchling-apps/BenchlingAppTypes';
import {BioentitySearchInputWithItems} from 'inventory/BioentitySearchInput';
import {StorableSearchInputWithItems} from 'samples/storables/StorableSearchInput';
import {Item} from 'ui-library/attach-dropdown/ItemSearchInput';

import LabelWrapper from '../shared/LabelWrapper';
import {SearchInputMultiValue} from '../UiBlockTypes';

interface SearchInputMultiValueUiBlockProps extends SearchInputMultiValue {
  onChangeValue: (blockId: string, val: Array<string>) => void;
}

const SearchInputWrapper = (props: SearchInputMultiValueUiBlockProps): JSX.Element | null => {
  const isEditable = props.enabled && props.canvasEnabled;
  const selectedIds = props.blockValue?.values || [];
  const selectedItems = selectedIds.map((v) => ({id: v}));

  const handleChange = (newItems: Array<Item>): void => {
    const newSelectedItemIds = new Set(newItems.flatMap((i) => (i.id ? i.id : [])));
    props.onChangeValue(props.id, [...newSelectedItemIds]);
  };

  switch (props.itemType) {
    case BenchlingAppType.dna_sequence:
    case BenchlingAppType.dna_oligo:
    case BenchlingAppType.aa_sequence:
    case BenchlingAppType.custom_entity:
    case BenchlingAppType.mixture:
      return (
        <BioentitySearchInputWithItems
          disabled={!isEditable}
          autoFocus={false}
          onChange={handleChange}
          tagSchemaOrInterfaceId={props.schemaId}
          bioentityTypes={[MODEL_CONSTANT_BY_APP_CONFIG_TYPE[props.itemType]]}
          selectedItems={selectedItems}
          shouldAllowMultiple={true}
          placeholderText={props.placeholder || undefined}
        />
      );
    case BenchlingAppType.box:
    case BenchlingAppType.container:
    case BenchlingAppType.location:
    case BenchlingAppType.plate:
      return (
        <StorableSearchInputWithItems
          disabled={!isEditable}
          autoFocus={false}
          onChange={handleChange}
          storableSchemaId={props?.schemaId || undefined}
          storableTypes={[props.itemType]}
          selectedItems={selectedItems}
          shouldAllowMultiple={true}
          placeholder={props.placeholder || undefined}
        />
      );
    default: {
      assertAndContinue(false, `Invalid Search Input Item type ${props.itemType}`);
      return null;
    }
  }
};

function SearchInputMultiValueUiBlock(props: SearchInputMultiValueUiBlockProps): JSX.Element {
  return (
    <div>
      <LabelWrapper label={props.label} required={props.required} />
      <SearchInputWrapper {...props} />
    </div>
  );
}

export default SearchInputMultiValueUiBlock;
